import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Box } from "@mui/material";

/**
 * Free-solo autocomplete used across the realtor filter bars.
 * Same API as before (inputWidth / items / type / onChange) — only the
 * styling changed, so every existing caller keeps working untouched.
 * `label` is optional and new.
 */
export default function BoxInput({ inputWidth, items, type, onChange, label }) {
  return (
    <Box sx={{ width: inputWidth }}>
      <Autocomplete
        freeSolo
        size="small"
        fullWidth
        options={(items || []).map((option) => option)}
        onInputChange={(e, newValue) => onChange(newValue)}
        onKeyPress={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
        renderInput={(params) => <TextField {...params} type={type} label={label} />}
      />
    </Box>
  );
}

BoxInput.defaultProps = {
  inputWidth: "150px",
};
